import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { HealthPlanEnrollmentsReportTableParams } from '../HealthPlanEnrollmentReport.types';

export const QUERY_KEY = 'EXPORT_HEALTH_PLAN_ENROLLMENT_REPORT_CSV';
const useHealthPlanEnrollmentsReportExportCSVQuery = (params: HealthPlanEnrollmentsReportTableParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const getEmployerIdParam = useGetEmployerIdParam();
  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(API_URL.REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_BREAKDOWN_EXPORT_CSV, {
        params: _.pickBy({
          ...getEmployerIdParam(params.employerId, params.employerIds),
          show_ssn: params.isSSNShowed,
          isSSNShowed: params.isSSNShowed,
          search_value: params.searchString,
          plan_year_period:
            params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
              ? params?.planYearPeriod.join(',')
              : undefined,
          plan_ids:
            params?.reportPlanIds && !params?.reportPlanIds.includes(ALL_OPTION_KEY)
              ? params?.reportPlanIds.join(',')
              : undefined,
        }),
      }),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response?.data?.data, 'csv', 'health-plan-enrollment-report');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default useHealthPlanEnrollmentsReportExportCSVQuery;
